import * as yup from 'yup';

export const spreadSheetFormSchema = yup.object().shape({
  spread_sheet_month: yup.string().required('É necessário informar o mês da exportação'),
  spread_sheet_year: yup.string().required('É necessário informar o ano da exportação'),
});
